import { computed as b, createElementBlock as t, openBlock as n, normalizeClass as m, createElementVNode as a, createCommentVNode as l, toDisplayString as r, Fragment as h, renderList as _, createVNode as x, unref as v, withCtx as w } from "vue";
import f from "../../../atoms/anchor-element/anchor-element.vue.js";
import { useTracking as C } from "../../../composables/useTracking.js";
/* empty css                                     */
const B = ["aria-label"], $ = { class: "ds-container" }, N = { class: "ds-grid" }, S = {
  key: 0,
  class: "ds-header-subnavigation__group ds-grid__col ds-grid__col--3"
}, q = {
  key: 0,
  class: "ds-heading"
}, z = {
  key: 1,
  class: "ds-text ds-margin-top-12"
}, D = {
  key: 0,
  role: "none"
}, T = { class: "ds-heading-xsmall" }, V = { class: "ds-color-black ds-text-small" }, L = /* @__PURE__ */ Object.assign({
  name: "DsHeaderSubnavigationHorizontal"
}, {
  __name: "header-subnavigation-horizontal",
  props: {
    /**
     * Sub navigation title
     */
    title: { type: String, required: !0 },
    /**
     * Sub navigation text
     */
    text: { type: String, required: !0 },
    /**
     * Sub navigation with background color, will add grey background color in the last item
     */
    withBackgroundColor: { type: Boolean, default: !0 },
    /**
     * Sub navigation items
     */
    items: {
      type: Array,
      required: !0,
      validator: (e) => e.every((s) => typeof s == "object" && ["title", "items"].every((d) => d in s))
    }
  },
  emits: ["link-clicked"],
  setup(e) {
    const { getTrackingText: s, trackingDataProvided: d } = C(), c = e, p = b(() => c.items.length === 3 && c.withBackgroundColor);
    return (u, g) => (n(), t("div", {
      class: m(["ds-header-subnavigation", { "ds-header-subnavigation--background": p.value }]),
      "aria-label": e.title,
      role: "menu"
    }, [
      a("div", $, [
        a("div", N, [
          e.title || e.text ? (n(), t("div", S, [
            e.title ? (n(), t("h4", q, r(e.title), 1)) : l("", !0),
            e.text ? (n(), t("p", z, r(e.text), 1)) : l("", !0)
          ])) : l("", !0),
          (n(!0), t(h, null, _(e.items.slice(0, 3), (o, k) => (n(), t("ul", {
            key: `item_${k}`,
            role: "none",
            class: m(["ds-header-subnavigation__group ds-grid__col--3", { "ds-header-subnavigation__group--with-space": !o.title }])
          }, [
            o.title ? (n(), t("li", D, [
              a("h5", T, r(o.title), 1)
            ])) : l("", !0),
            (n(!0), t(h, null, _(o.items, (i, y) => (n(), t("li", {
              key: `sub-item__${y}`,
              class: "ds-margin-top-12",
              role: "none"
            }, [
              x(f, {
                "tracking-data": { "component-name": u.$options.name, text: v(s)(o, k, i), level: 2, ...v(d) },
                url: i.url,
                "open-in-new-window": i.openInNewWindow,
                nuxt: i.nuxt,
                class: "ds-button-link ds-button-link--secondary ds-button-link--green ds-header-subnavigation__link",
                role: "menuitem",
                onClick: g[0] || (g[0] = (j) => u.$emit("link-clicked"))
              }, {
                default: w(() => [
                  a("span", null, r(i.title), 1),
                  a("span", V, r(i.text), 1)
                ]),
                _: 2
              }, 1032, ["tracking-data", "url", "open-in-new-window", "nuxt"])
            ]))), 128))
          ], 2))), 128))
        ])
      ])
    ], 10, B));
  }
});
export {
  L as default
};
